<fin-booking-widget-selector
  class="flex flex-1 grow"
  [label]="'bookingWidgetTabs.hotels.guestsAndRooms' | finLocalization"
  [filled]="true"
  (click)="openModal()"
  data-testid="guests-and-rooms-selector"
>
  <div class="flex flex--middle">
    <fcom-icon
      class="icon-small ms-xxsmall-r"
      [name]="totalAdults + totalChildren > 1 ? SvgLibraryIcon.MULTI_PAX : SvgLibraryIcon.SINGLE_PAX"
    />
    <span class="flex flex--wrap" data-testid="guests-and-rooms-summary">
      <span>{{ 'bookingWidgetTabs.hotels.guests.totalAdults' | finPluralLocalization: totalAdults }}</span>
      @if (totalChildren > 0) {
        <span>, {{ 'bookingWidgetTabs.hotels.guests.totalChildren' | finPluralLocalization: totalChildren }}</span>
      }
      <span>, {{ 'bookingWidgetTabs.hotels.guests.totalRooms' | finPluralLocalization: rooms.length }}</span>
    </span>
  </div>
</fin-booking-widget-selector>

<fcom-modal
  [(open)]="modalOpen"
  (close)="emitSelectedRooms()"
  [title]="'bookingWidgetTabs.hotels.guestsAndRooms' | finLocalization"
  [fitToContent]="true"
  [roundedContent]="true"
  [buttons]="null"
  data-testid="guests-and-rooms-modal"
>
  <ul id="hotel-rooms" class="flex flex--column pr-large-x no-list-style" tabindex="-1">
    @for (room of rooms; track $index; let roomIndex = $index, last = $last) {
      <li [id]="'hotel-room-' + roomIndex" class="block pr-medium-b ms-medium-t" [ngClass]="{ 'border-bottom': !last }">
        <div class="flex flex--space-between flex--middle">
          <span class="nordic-blue-900-text text-icon-primary font-body-medium-bold">
            {{ 'bookingWidgetTabs.hotels.room' | finLocalization }} {{ roomIndex + 1 }}
          </span>
          @if (roomIndex > 0) {
            <fcom-button
              (clickBtn)="removeRoom(roomIndex)"
              [aria]="{ controls: 'hotel-room-' + roomIndex }"
              [text]="'bookingWidgetTabs.hotels.remove' | finLocalization"
              [theme]="ButtonTheme.TERTIARY_GHOST"
              [attr.data-testid]="'remove-room-' + roomIndex"
            />
          }
        </div>

        <div class="flex flex--space-between flex--center ps-xsmall-y fill">
          <div class="font-body-medium flex-1">
            {{ 'bookingWidgetTabs.hotels.guests.adult' | finLocalization }}
          </div>
          <div class="guest-selector">
            <fin-plus-minus-selector
              class="nordic-blue-900-text text-icon-primary"
              [min]="ROOM_CONFIG.adults.min"
              [max]="ROOM_CONFIG.adults.max"
              [model]="room.adults"
              [decreaseLabel]="'bookingWidgetTabs.hotels.guests.removeAdult' | finLocalization"
              [increaseLabel]="'bookingWidgetTabs.hotels.guests.addAdult' | finLocalization"
              [title]="room.adults.toString()"
              [iconSize]="'icon-large'"
              [textSize]="'font-headline-small'"
              [buttonPadding]="false"
              [controls]="'room-' + roomIndex + '-adults'"
              (increment)="onAdultsUpdate(AmountUpdateType.INCREMENT, roomIndex)"
              (decrement)="onAdultsUpdate(AmountUpdateType.DECREMENT, roomIndex)"
            />
          </div>
        </div>

        <div class="flex flex--space-between flex--center ps-xsmall-y fill">
          <div class="font-body-medium flex-1">
            <div>{{ 'bookingWidgetTabs.hotels.guests.child' | finLocalization }}</div>
            <div class="nordic-blue-400-text text-icon-secondary font-body-small">
              {{ 'bookingWidgetTabs.hotels.guests.ageUponCheckIn' | finLocalization }}
            </div>
          </div>
          <div class="guest-selector">
            <fin-plus-minus-selector
              class="nordic-blue-900-text text-icon-primary"
              [min]="ROOM_CONFIG.children.min"
              [max]="ROOM_CONFIG.children.max"
              [model]="room.children"
              [decreaseLabel]="'bookingWidgetTabs.hotels.guests.removeChild' | finLocalization"
              [increaseLabel]="'bookingWidgetTabs.hotels.guests.addChild' | finLocalization"
              [title]="room.children.toString()"
              [iconSize]="'icon-large'"
              [textSize]="'font-headline-small'"
              [buttonPadding]="false"
              [controls]="'room-' + roomIndex + '-children'"
              (increment)="onChildrenUpdate(AmountUpdateType.INCREMENT, roomIndex)"
              (decrement)="onChildrenUpdate(AmountUpdateType.DECREMENT, roomIndex)"
            />
          </div>
        </div>

        <form [formGroup]="room.childrenForm">
          <ul class="flex flex--column no-list-style">
            @for (control of room.childrenForm.controls | keyvalue; track control.key; let childIndex = $index) {
              <li class="flex flex--column ms-small-b">
                <fin-select-input
                  class="block"
                  [controlName]="control.key"
                  [parentForm]="room.childrenForm"
                  [required]="true"
                  [options]="childAgeOptions$ | async"
                  [displayMargin]="false"
                  [selectLabelTranslationKey]="'bookingWidgetTabs.hotels.guests.ageSelect'"
                  [translationPrefix]="'bookingWidgetTabs.hotels.guests.childAge'"
                  [label]="('bookingWidgetTabs.hotels.guests.ageOfChild' | finLocalization) + ' ' + (childIndex + 1)"
                  (change)="emitSelectedRooms()"
                />
              </li>
            }
          </ul>
        </form>
      </li>
    }
  </ul>

  @if (rooms.length < ROOM_CONFIG.maxRooms) {
    <div class="pr-large-x ms-medium-y">
      <fcom-button
        (clickBtn)="addRoom()"
        [aria]="{ controls: 'hotel-rooms' }"
        [icon]="{ name: SvgLibraryIcon.PLUS, position: IconPosition.LEFT }"
        [text]="'bookingWidgetTabs.hotels.addRoom' | finLocalization"
        [theme]="ButtonTheme.SECONDARY_OUTLINE"
        data-testid="add-room-button"
      />
    </div>
  }

  <div class="pr-large-x ms-medium-b flex flex--end">
    <fcom-button
      [text]="'actions.done' | finLocalization"
      [theme]="ButtonTheme.SECONDARY_OUTLINE"
      (clickBtn)="done()"
      data-testid="guests-and-rooms-done-button"
    />
  </div>
</fcom-modal>
